export function TQLGlobeSVG() {
	return (
		<svg
			preserveAspectRatio={"xMidYMid meet"}
			viewBox={"219 11 99 99"}
			xmlSpace={"preserve"}
			xmlns={"http://www.w3.org/2000/svg"}
		>
			<g>
				<g>
					<g>
						<path
							d={
								"M273.1,62.5c13.4-6.1,24-16.7,30.2-29.9c-10.3-12.6-27.2-19-44.1-15c-22,5.2-36.2,26.2-33.5,48.1C242.3,70.4,259.2,68.9,273.1,62.5z"
							}
							fill={"#0093C9"}
						/>
						<path
							d={
								"M312,50.2c-1-4-2.4-7.8-4.3-11.2c-2.6,14-9,26.5-18.3,36.1c-11.7,12.2-28.1,19.7-46,20.6c10,7.3,23,10.4,36,7.3C302.9,97.4,317.5,73.8,312,50.2z"
							}
							fill={"#0093C9"}
						/>
						<path
							d={
								"M219.5,75c-0.2-0.2-0.3-0.5-0.5-0.7C219.2,74.5,219.4,74.8,219.5,75z"
							}
							fill={"#0093D0"}
						/>
						<path
							d={
								"M220.8,77.1c-0.1-0.2-0.3-0.4-0.4-0.6C220.6,76.7,220.7,76.9,220.8,77.1z"
							}
							fill={"#0093D0"}
						/>
						<path
							d={
								"M281.1,69c16.3-11.4,26.7-30.3,27.2-51.7l0,0l0,0l0,0c-1.1,21.1-12.2,39.6-28.9,50.4c-16.6,10.8-39,13.9-60.6,6.2l0,0c0.1,0.1,0.2,0.3,0.2,0.4c0.2,0.2,0.3,0.5,0.5,0.7c0.3,0.5,0.6,1,0.9,1.5c0.1,0.2,0.3,0.4,0.4,0.6c0.1,0.2,0.2,0.4,0.3,0.5l0,0C242.9,84.4,264.9,80.5,281.1,69z"
							}
							fill={"#0093C9"}
						/>
					</g>
				</g>
			</g>
		</svg>
	);
}
